'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMpAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#1E8BD6" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 16.6667C17.6819 16.6667 20.6667 13.6819 20.6667 10C20.6667 6.3181 17.6819 3.33333 14 3.33333C10.3181 3.33333 7.33333 6.3181 7.33333 10C7.33333 13.6819 10.3181 16.6667 14 16.6667ZM14 15.3333C11.0545 15.3333 8.66667 12.9455 8.66667 10C8.66667 7.05448 11.0545 4.66667 14 4.66667C16.9455 4.66667 19.3333 7.05448 19.3333 10C19.3333 12.9455 16.9455 15.3333 14 15.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9171 7.99604C11.963 7.26185 12.5904 6.66667 13.3321 6.66667H14.6683C15.4039 6.66667 16.0379 7.27072 16.0833 7.99604L16.5838 16.004C16.6297 16.7382 16.0757 17.3333 15.321 17.3333H12.6794C11.9361 17.3333 11.3713 16.7293 11.4166 16.004L11.9171 7.99604Z",
          fill: "#A9A7A9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0001 12.6867L11.2571 14.6421L12.2692 11.4291L9.56185 9.42462L12.9303 9.39429L14.0001 6.20003L15.0699 9.39429L18.4384 9.42462L15.731 11.4291L16.7431 14.6421L14.0001 12.6867Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagMpAsset = forwardRef(FlagMpAsset);

export { VpFlagMpAsset as default };
